import { renderTitleNames } from '@utils/notificationUtils'
import { useNavigate } from 'react-router-dom'
import { NotificationRepostIcon } from '../NotificationIcons'
import NotificationDisplay from '../NotificationDisplay'

const RepostDisplayByPost = ({ users, post }) => {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(`/posts/${post.uuid}`, { state: { post }})
  }

  return (
    <NotificationDisplay
      Icon={NotificationRepostIcon}
      users={users}
      title={<span>{renderTitleNames(users)} reposted your post</span>}
      body={post?.body}
      clickCallback={handleClick}
    />
  )
}

export default RepostDisplayByPost
